const TableItensHeaders = [
    {
        label: 'Status',
        key: 'situacao',
        isVisible: true,
    },
    {
        label: 'ID',
        key: 'idProduto',
        isVisible: true,
    },
    {
        label: 'Descrição Produto',
        key: 'produto',
        isVisible: true,
    },
    {
        label: 'Solicitado',
        key: 'solicitada',
        isVisible: true,
    },
    {
        label: 'Auditado',
        key: 'auditada',
        isVisible: true,
    },
    {
        label: 'Divergência',
        key: 'divergente',
        isVisible: true,
    },
]

export default TableItensHeaders;